export default "__VITE_ASSET__4b27f54e__"